import React from 'react'
import Countdown from 'react-countdown'
import {
  default as CountDownType,
  CountDownTimeDataType,
  CountDownTimerType,
  CountDownTextColors
} from './CountDown.types'
import * as CountDownTimerStyles from './CountDown.styles'

function rendererTimeInfo(name: string, color: string) {
  return <span className={CountDownTimerStyles.TimerInfo + color}>{name}</span>
}

function rendererTimeBlock(
  name: string,
  value: string | number,
  color: string,
  index: number
) {
  return (
    <div
      className={CountDownTimerStyles.TimerBlock + color}
      key={`${name}-${index}`}
    >
      {value}
      {rendererTimeInfo(name, color)}
    </div>
  )
}

const CountDownComponent = (props: CountDownType) => {
  const {
    colorScheme = 'white',
    countdownDate,
    customCssClass = '',
    onComplete = () => {}
  } = props
  const color = CountDownTextColors[colorScheme]

  function rendererTimer({
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0,
    completed
  }: CountDownTimerType) {
    const timerData: CountDownTimeDataType[] = [
      {
        name: 'Days',
        value: days
      },
      {
        name: 'Hrs',
        value: hours
      },
      {
        name: 'Min',
        value: minutes
      },
      {
        name: 'Sec',
        value: seconds
      }
    ]

    if (completed) {
      return <span />
    }

    return (
      <>
        {timerData.map((time: CountDownTimeDataType, index: number) =>
          rendererTimeBlock(time.name, time.value, ` ${color}`, index)
        )}
      </>
    )
  }

  return (
    <div className={CountDownTimerStyles.TimerWrapper + ` ${customCssClass}`}>
      <Countdown
        date={countdownDate}
        renderer={rendererTimer}
        onComplete={onComplete}
      />
    </div>
  )
}

export default CountDownComponent
